import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import { ItemImage } from '../ItemImage'
import { Price } from '../Price'

import translations from '../../../../../../public/data/translations.json'

export const Item = ({ item, isLoading, isPromoted }) => {
  const { t, lang } = useTranslation('common')
  const locale = lang?.toUpperCase() || 'ME'

  const {
    name,
    thumbnail,
    price,
    discounted_price,
    discount,
    group,
    product_description,
    availability,
    show_discount,
    availableQuantity,
    tire_season_slug,
    imageTags
  } = item

  const DescriptionGume = ({ product_description }) => {
    const width = product_description[0]?.value
    const height = product_description[1]?.value
    const diameter = product_description[2]?.value
    const season = product_description[3]?.value

    return (
      <div className='ads-list-item-description-specs'>
        <span className='ads-list-item-description-specs-item'>
          {width}/{height} R{diameter}
        </span>

        <span className='ads-list-item-description-specs-item'>
          {t(`${season}`)}
        </span>
      </div>
    )
  }

  const href = {
    pathname: '/vehiclePart',
    query: { slug: name?.slug }
  }

  const as = `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}/${translations.proizvod[locale]}/${name?.slug}`

  return (
    <div className='ads-list-item'>
      <ItemImage
        isPromoted={isPromoted}
        img={`https://slikeprodavnica.autodiler.me/thumbs${thumbnail}`}
        title={name?.name || ''}
        as={as}
        href={href}
        tire_season_slug={tire_season_slug}
        imageTags={imageTags}
      />

      <Link as={as} href={href}>
        <a className='ads-list-item-title ads-list-item-title--vehicle-part'>
          <h3>{name?.name || ''}</h3>
        </a>
      </Link>

      <div className='ads-list-item-description ads-list-item-description-vehicle-part'>
        <DescriptionGume product_description={product_description} />
      </div>

      <Price price={price} priceWithDiscount={discounted_price} availability={availability} showDiscount={show_discount} />

      <div className={'ads-list-item-bottom-section'}>
        <span>{availableQuantity?.text || ''}</span>
      </div>
    </div>
  )
}

Item.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    }).isRequired,
    group: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    }).isRequired,
    product_description: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })).isRequired,
    ean: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    discounted_price: PropTypes.string,
    discount: PropTypes.string,
    availability: PropTypes.shape({
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    }).isRequired,
    availableQuantity: PropTypes.shape({
      value: PropTypes.string.number,
      color: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      showPlus: PropTypes.bool.isRequired,
    }).isRequired,
    imageTags: PropTypes.array
  }).isRequired,
  isLoading: PropTypes.bool.isRequired
}
